export interface RemoteDevice {
  code: string;
  name: string;
  model: string;
  firmware: string;
}

export const REMOTE_DEVICES: RemoteDevice[] = [
  { code: "774219", name: "AURA Pro Max", model: "AMX-900", firmware: "v2.4.1" },
  { code: "552810", name: "AURA Mini", model: "AMX-500", firmware: "v1.8.0" },
  { code: "930144", name: "AURA Air", model: "AMX-300", firmware: "v1.3.2" },
];